export default __webpack_public_path__ + "static/media/placement-loader.8ab7f444.gif";